import { render, staticRenderFns } from "./RegionTree.vue?vue&type=template&id=95b6b0ac&scoped=true&"
import script from "./RegionTree.vue?vue&type=script&lang=js&"
export * from "./RegionTree.vue?vue&type=script&lang=js&"
import style0 from "./RegionTree.vue?vue&type=style&index=0&id=95b6b0ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b6b0ac",
  null
  
)

export default component.exports